import React from 'react';
import { saveVisit } from '../../api/visitTrackerService';

const NotFound = () => {
    saveVisit('404 page visited');

    return (
        <div className="page-center">
            <h1>Page not found</h1>
            <p>Sorry, this page doesn't exist.</p>
            <a href="/" className="btn btn-outline">Go home</a>
        </div>
    );
};

export default NotFound;
